<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 shadowSpacing">
  <ng-container *ngFor="let value of columns; let i = index" [matColumnDef]="value">
    <th mat-header-cell *matHeaderCellDef>
      <ng-container *ngIf="names.length > 0">{{ names[i] }}</ng-container>
      <ng-container *ngIf="names.length === 0">{{ value }}</ng-container>
    </th>
    <td mat-cell *matCellDef="let data">
      <div *ngIf="value !== 'delete'">
        {{ data[value] }}
      </div>

      <div *ngIf="value === 'delete'">
        <button class="btn-round-red" (click)="delete(data.username)" mat-medium-icon-button>
          <mat-icon style="font-size: 20px; margin-top: 5px">delete</mat-icon>
          <span></span>
        </button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" (click)="clicked(row)"></tr>
</table>

<usimweb-paginator [pageSizeOptions]="[10, 20, 50]"></usimweb-paginator>
